import * as React from "react";

import { Button } from "carbon-components-react";
import { AppShape, HurdleShape } from "@eave/shared/types/api";
import HurdleView from "underwriter_dashboard/shared/HurdleView";
import WorksheetEditor from "../shared/WorksheetEditor";
import CloneModalButton from "../shared/CloneModalButton";

const styles = require("underwriter_dashboard/hurdle_editors/styles.module.scss");

interface IProps {
  app: AppShape;
  hurdle: HurdleShape;
  onHide: Function;
}

class LoanFileWorksheet extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      readOnly: true,
      showHidden: true,
    };
  }

  render() {
    const { app, hurdle, onHide } = this.props;
    const { readOnly, showHidden } = this.state;

    return (
      <HurdleView app={app} hurdle={hurdle} onHide={onHide}>
        <div style={{ marginBottom: 20 }}>
          <CloneModalButton app={app} />
          <Button
            kind="secondary"
            style={{ marginRight: "10px" }}
            onClick={() => this.setState({ showHidden: !showHidden })}
          >
            {showHidden ? "Hide" : "Show"} hidden fields
          </Button>
          <Button
            kind="secondary"
            style={{ marginRight: "10px" }}
            onClick={() => this.setState({ readOnly: !readOnly })}
          >
            {readOnly ? "Allow" : "Disallow"} editing
          </Button>
        </div>
        <WorksheetEditor
          appId={app.id}
          loanFileWsId={app.loan_file_worksheet_id}
          openToWsName="loan_file"
          showChildrenInline
          readOnly={readOnly}
          showHidden={showHidden}
        />
      </HurdleView>
    );
  }
}

export default LoanFileWorksheet;
